import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';

import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { LoggerService } from './logger.service';


@Injectable({
    providedIn: 'root'
})
export class ApiCommonServicesService {
    groupContacts: any;
    checkCoporateNameEndPoint: string = '/api/cp/admin/corporate/checkCorporateName';
    apiUrl: string = environment.apiUrl;
    url: string = '/api/cp/admin/corporate/';



    // headers: HttpHeaders | { [header: string]: string | string[]; };
    token: any = 'Bearer ' + sessionStorage.getItem('accessToken');
    headers = new HttpHeaders().set('Authorization', this.token).set('Content-Type', 'application/json');

    constructor(private logger: LoggerService, private http: HttpClient) {
    }

    apiHeaders() {
        var corporateId = sessionStorage.getItem("corporateId");
        var accessToken = sessionStorage.getItem('accessToken');
        return {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
            'corpId': corporateId,
        }
    }
    getGroupContactList() {
        this.logger.log("getGroupContactList: ");
        var corporateId = sessionStorage.getItem('corporateId');
        var accessToken = sessionStorage.getItem('accessToken');
        var GetGroupcontacts = '/api/cp/admin/corporate/' + corporateId + '/groupAdmins';

        this.http.get(environment.apiUrl + GetGroupcontacts, {
            // headers: {
            //   Authorization: 'Bearer ' + accessToken,
            //   'Content-Type': 'application/json',
            // },
            headers: this.apiHeaders(),
        })
            .subscribe(
                (response: any) => {
                    if (response['status'] == 200) {

                        this.groupContacts = response.data;
                        this.logger.log("this.groupContacts: " + JSON.stringify(this.groupContacts));


                        // this.lengthofemployee = this.employeeList.length;
                        // this.maxEmployees = this.employeeList.length;
                    } else {
                        Swal.fire({ title: 'Error', text: response.message });
                    }
                },
                (error) => {
                    this.logger.log(error);
                    Swal.fire({ title: 'Error', text: error.error.error.message });
                }
            );
        return this.groupContacts;
    }

    // private getHeaders(): HttpHeaders {
    //   // You can customize headers like adding an authentication token here
    //  var token: any = 'Bearer ' + sessionStorage.getItem('accessToken');
    //   const headers = new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': token
    //   });
    //   return headers;
    // }
    // private handleError(error: any): Observable<never> {
    //   console.error('An error occurred', error);
    //   return throwError(() => error.message || error);
    // }
    // async getDetails(): Promise<any> {
    //   var CorpId = sessionStorage.getItem("corporateId");
    //   var url = this.apiUrl+this.url + CorpId + '/details';
    //   return await this.http.get(url, { headers: this.getHeaders() })
    //     .pipe(
    //       map((response: any) => response),
    //       catchError(this.handleError)
    //     ).toPromise();
    // }

    async getHeaders() {
        var token: any = 'Bearer ' + sessionStorage.getItem('accessToken');
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token
            // Add any other headers if needed
        };
        return headers;
    }
    async getDetails() {
        try {
            const corpId = sessionStorage.getItem("corporateId");
            const headers = await this.getHeaders();
            var details = await fetch(environment.apiUrl + '/api/cp/admin/corporate/' + corpId + '/details', { headers });
            return await details.json();
        } catch (error) {
            console.error('An error occurred', error);
            throw error;
        }
    }
    // return this.http.post(url, data, { headers: this.getHeaders() })
    //   .pipe(
    //     map((response: any) => response),
    //     catchError(this.handleError)
    //   );
    // async checkCorporationNameIsExist(input: any) {
    //   let isExist: boolean ;
    //   var accessToken = sessionStorage.getItem('accessToken');
    //   var obj: any = {
    //     name: input
    //   };
    //   this.logger.log("obj isExist: " + JSON.stringify(obj))
    //  await this.http
    //     .post(environment.apiUrl + this.checkCoporateNameEndPoint, obj, {
    //       headers: {
    //         Authorization: 'Bearer ' + accessToken,
    //         'Content-Type': 'application/json',
    //       },
    //     })
    //     .subscribe((response: any) => {
    //       this.logger.log("checkCorporationNamesExist: " + JSON.stringify(response))
    //       if (response.status == 200) {
    //         if (response.data.count != 0) {
    //            Swal.fire({ title: 'Error', text: 'Corporation Name already exists' });
    //           this.logger.log("checkCorporationNameIsExist: true" + isExist)
    //           isExist = true;
    //           this.logger.log("checkCorporationNameIsExist: true" + isExist)
    //         } else {
    //           isExist=false;
    //         }

    //       }
    //       else if (response.data.count != 0){
    //         if (response.data.count != 0) {
    //           this.manageClient.client['corporationName'].reset();
    //            Swal.fire({ title: 'Error', text: 'Corporation Name already exists' });
    //           this.logger.log("checkCorporationNameIsExist: true" + isExist)
    //           isExist = true;
    //           this.logger.log("checkCorporationNameIsExist: true" + isExist)
    //         } else {
    //           isExist=false;
    //         }
    //       }
    //     });
    //   this.logger.log("return : "+isExist)
    //   return isExist;
    // }

    // if true means pad become true if false means cc become true
    // Update payment method
    public updatePaymentMethod(input: any, corporateId = 0) {
        // https://gigtest.testcorporate.groupbenefitz.aitestpro.com/roe?customerId=12690648&success=True&paymentMethodId=2992063
        var CorpId = sessionStorage.getItem("corporateId");
        var endPoint = '/api/ap/admin/corporate/' + (corporateId > 0 ? corporateId : CorpId) + '/corporatePaymentMethod';
        var accessToken = sessionStorage.getItem('accessToken');
        //Added by sudeep.k on Apr 03 2024, for paymentMethodId going as null in payload fix
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const paymentMethodId = urlParams.get('paymentMethodId');
        var obj = {
            "pad": input == true ? true : false,
            "cc": input == true ? false : true,
            "paymentMethodId": paymentMethodId ?? ""
        };
        this.http
            .post(environment.apiUrl + endPoint, obj, {
                // headers: {
                //   Authorization: 'Bearer ' + accessToken,
                //   'Content-Type': 'application/json',
                // },
                headers: this.apiHeaders(),
            })
            .subscribe(
                (response: any) => {
                    if (response['status'] == 200) {
                        this.logger.log("corporatePaymentMethod: update" + JSON.stringify(response));
                        // Swal.fire({ title: 'Info', text: response.message })

                    } else {
                        Swal.fire({ title: 'Error', text: response.message });
                    }
                });

    }

}